import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "./utils/api/config.ts";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./contexts/AuthContext";
import ConfirmDialog from "./components/common/Dialog/Dialog.tsx";
import "react-datepicker/dist/react-datepicker.css";
import { DEVELOPMENT } from "./utils/api/config.ts";
import { TooltipProvider } from "./components/ui/tooltip.tsx";

export const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
	<GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
		<QueryClientProvider client={queryClient}>
			<React.StrictMode>
				<Toaster />
				<AuthProvider>
					<TooltipProvider>
						<App />
						<ConfirmDialog />
					</TooltipProvider>
				</AuthProvider>
				{DEVELOPMENT === "development" ? (
					<ReactQueryDevtools initialIsOpen={false} />
				) : null}
			</React.StrictMode>
		</QueryClientProvider>
	</GoogleOAuthProvider>
);
